import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Mutation } from 'react-apollo'
import { REPEAT_ORDER } from '../../mutations'
import { Link, withRouter } from 'react-router-dom'
import Error from '../../components/Error'
import RepeatOrderPopup from '../SubmitOrderPopup/RepeatOrderPopup'

import { FlexContainer } from '../../styles/defaults'
import {
  ProductContainer,
  OrderContainer,
  Wrapper,
  Title,
  Button,
  StickyOrder,
  StickyAmount,
  StickyButton,
  ProductHeader,
  ProductTitle,
  DesktopWrapper,
  MobileWrapper,
  Content,
  Notes
} from './styles'

import Order from '../Order/'
import EmployeeCTA from '../EmployeeCTA/'

import employee from '../../assets/cta/employee.png'

class OldOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredProducts: [],
      popupActive: false,
      query: ''
    }
  }

  calculateOrders() {
    let amount = 0
    Object.keys(this.props.order).map((key, index) => {
      return (amount = amount + this.props.order[key])
    })
    return amount
  }

  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })

    const { strippedProducts } = this.props

    const result =
      queryLength === 0
        ? []
        : strippedProducts.filter(
            product =>
              product.firstDescription.toLowerCase().slice(0, queryLength) === query ||
              product.firstDescription.toLowerCase().indexOf(query) !== -1 ||
              product.productCode.toLowerCase().slice(0, queryLength) === query
          )
    if (result.length > 0) {
      this.setState({ filteredProducts: result })
    } else {
      this.setState({ filteredProducts: [] })
    }
  }

  handleClick(e) {
    this.setState({ popupActive: true })
    document.body.classList.add('popup-active')
    document.documentElement.classList.add('popup-active')
  }

  closePopup() {
    this.setState({ popupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }

  render() {
    const order = this.props.wholeOrder
    this.order = order
    let productTypes = {
      coffee: {
        description: 'Koffie',
        products: order.orderParts.filter(orderPart =>
          ['KFB', 'KFBF', 'KFG', 'KFGF', 'KFL', 'KFLF', 'KFV', 'KFVF', 'KFBRA', 'KFGRF', 'KFVRF'].includes(orderPart.product.category.category)
        )
      },
      thee: {
        description: 'Thee',
        products: order.orderParts.filter(orderPart => ['THE', 'THEF', 'THERF'].includes(orderPart.product.category.category))
      },
      food: {
        description: 'Food',
        products: order.orderParts.filter(orderPart =>
          ['SOE', 'KOE', 'CAC', 'TOP', 'SUI', 'MLK', 'FRI'].includes(orderPart.product.category.category)
        )
      },
      nonFood: {
        description: 'Non-food',
        products: order.orderParts.filter(orderPart =>
          ['BEK', 'BEP', 'ROE', 'HYG', 'SMK', 'REI', 'SER', 'ONF', 'FIL'].includes(orderPart.product.category.category)
        )
      },
      notes: {
        description: 'Notities',
        products: order.orderParts.filter(orderPart =>
          ['TXT'].includes(orderPart.product.category.category)
        )
      }
    }

    let employeeContent = {
      title: 'Vragen?',
      subtitle: 'We helpen u graag',
      employee: true,
      image: employee,
      link: {
        content: 'Contact',
        url: '/contact',
        target: ''
      }
    }
    
    return (
      <FlexContainer full mb>
        <ProductContainer>
          {Object.keys(productTypes).map((type, index) => {
            if (productTypes[type].products.length > 0) {
              if (type === 'notes') {
                return (
                  <Fragment key={index}>
                    <ProductHeader>
                      <ProductTitle>{productTypes[type].description}</ProductTitle>
                    </ProductHeader>
                    <Notes>
                      <ul>
                        {productTypes[type].products.map((note, index) => {
                          return <li key={index}>{note.note}</li>
                        })}
                      </ul>
                    </Notes>
                  </Fragment>
                )
              }
              return (
                <Fragment key={index}>
                  <ProductHeader>
                    <ProductTitle>{productTypes[type].description}</ProductTitle>
                    {productTypes[type].description !== 'Overig' ? (<Link to={`/assortiment/${productTypes[type].description.toLowerCase()}`}>Bekijk assortiment</Link>) : null}
                  </ProductHeader>
                  {productTypes[type].products.map((orderPart, index) => {
                    return (
                      <Order
                        key={orderPart.product.id + '-' + index}
                        product={orderPart.product}
                        wholeOrder={this.props.wholeOrder}
                        orderParts={this.props.order}
                        orderId={this.props.orderId}
                        order={this.props.order[`${orderPart.id}`]}
                        editOrder={false}
                        servicePackage={this.props.servicePackage}
                        branchData={this.props.branchData}
                      />
                    )
                  })}
                </Fragment>
              )
            } else {
              return null
            }
          })}
        </ProductContainer>


        <OrderContainer>
          <Wrapper secondChild>
            <Title>Informatie</Title>
            <Content>
              <div>Producten</div>
              <div>{this.calculateOrders()} st.</div>
            </Content>
            <Content>
              <div>Leverdatum</div>
              <div>{moment(order.deliveryDate).format('DD-MM-YYYY')}</div>
            </Content>
            <Content>
              <div>Ordernummer</div>
              <div>{order.orderNumber}</div>
            </Content>
            {this.props.editOrder ? (
              <Fragment>
                <Content>
                  <p>Wil je deze bestelling opnieuw in je bestellijst plaatsen?</p>
                </Content>
                <Button onClick={this.handleClick.bind(this)}>Kopiëren</Button>
              </Fragment>
            ) : null}
          </Wrapper>
          <DesktopWrapper>
            <EmployeeCTA size={'small'} mt content={employeeContent} />
          </DesktopWrapper>
        </OrderContainer>
        <Content mobile />
        <Content mobile>
          <div>Leverdatum</div>
          <div>{moment(order.deliveryDate).format('DD-MM-YYYY')}</div>
        </Content>
        <Content mobile>
          <div>Ordernummer</div>
          <div>{order.orderNumber}</div>
        </Content>
        {this.props.editOrder ? (
          <Fragment>
            <Content mobile>
              <p>Wil je deze bestelling opnieuw in je bestellijst plaatsen?</p>
            </Content>
            <StickyOrder>
              <StickyAmount>
                Producten
                <strong>{this.calculateOrders()} st.</strong>
              </StickyAmount>

              <StickyButton onClick={this.handleClick.bind(this)}>Kopiëren</StickyButton>
            </StickyOrder>
          </Fragment>
        ) : (
          <Fragment>
            <StickyOrder>
              <StickyAmount>
                Producten
                <strong>{this.calculateOrders()} st.</strong>
              </StickyAmount>
            </StickyOrder>
          </Fragment>
        )}

        <MobileWrapper>
          <EmployeeCTA size={'small'} mt content={employeeContent} />
        </MobileWrapper>

        {this.state.popupActive ? (

          <Mutation 
            mutation={REPEAT_ORDER}
          >
          {(repeatOrder, { data, loading, error }) => {
            if (data) {
              window.location.href = '/bestellijst'
            }
            if (error) return <Error error="de nieuwe product aantallen." />

            return (
              <RepeatOrderPopup
                closePopup={this.closePopup.bind(this)}
                id={this.props.orderId}
                repeatOrder={repeatOrder}
                title={'De aantallen van deze bestelling worden in uw bestellijst geplaatst.'}
                confirm={'Ja, kopieer deze bestelling'}
                deny={'Annuleren'}
                user={this.props.user}
              />
            )
          
          }}
          </Mutation>
        ) : null}
      </FlexContainer>
    )
  }
}

export default withRouter(OldOrders)



// WEBPACK FOOTER //
// ./src/components/OldOrders/index.js